import React from 'react'
import { ConvertUom } from '../ConvertUom'
import {
    defaultThrottleUOMUnit,
    parseMillisecondsToUOM,
    getThrottleUOMUnit,
    getOptionsUOMSelector,
    getThrottleUOMLabel
} from './throttleMSHelper'
import { FormatTimeUom, ThrottleMSProps } from './types'

import i18n from 'live/services/i18n'

export function ThrottleMS({ current, onChangeValue, onChangeUom }: ThrottleMSProps) {
    const inputProps = {
        value: parseMillisecondsToUOM(current.value, getThrottleUOMUnit(current.formatTimeUom), FormatTimeUom.m),
        onChange: onChangeValue
    }

    const labelProps = {
        title: i18n('Throttle Period'),
        tooltip:
            i18n('In case the alert rule triggers multiple times in a short period of time, the throttle period avoids the report of being sent multiple times.'),
        required: true
    }

    const optionsProps = {
        styles: CustomListThrottleStyles,
        options: getOptionsUOMSelector(),
        defaultValue: getThrottleUOMLabel(current?.formatTimeUom) || getThrottleUOMLabel(defaultThrottleUOMUnit),
        closeMenuOnSelect: true,
        editMode: true,
        onChange: onChangeUom,
        required: true,
        isSearchable: false
    }

    return <ConvertUom inputProps={inputProps} labelProps={labelProps} optionProps={optionsProps} />
}

const CustomListThrottleStyles = {
    container: styles => ({
        ...styles,
        borderStyle: 'none !important',
        height: '38px',
        minHeight: '38px',
        maxHeight: '38px !important',
        width: '50% !important'
    }),
    option: styles => ({
        ...styles,
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '14px ',
        fontSize: '14px '
    }),
    control: (styles, state) => ({
        ...styles,
        border: state.isFocused ? '1px solid var(--blue-500) !important' : '1px solid #C8CCD4 !important',
        overflow: 'hidden !important',
        maxHeight: '38px !important',
        borderRadius: '0px  3px 3px 0 !important',
        boxShadow: 'none'
    }),
    valueContainer: styles => ({
        ...styles,
        maxHeight: '38px !important',
        width: 'auto'
    }),
    indicatorSeparator: styles => ({
        ...styles,
        display: 'none'
    }),
    placeholder: styles => ({
        ...styles,
        position: 'absolute',
        top: '50%',
        width: '100%'
    }),
    menu: styles => ({
        ...styles,
        borderRadius: '0px'
    }),
    singleValue: styles => ({
        ...styles,
        overflow: 'hidden !important',
        height: '100%',
        // marginTop: '2px', //added the isSearchble false and adjusted the placement
        color: 'var(--blue-500)',
        fontWeight: '600',
        fontSize: '13px',
        // top: '70%'
    }),
    dropdownIndicator: base => ({
        ...base,
        color: '#333', // Define a cor do ícone
        '&:hover': {
            color: '#666' // Define a cor do ícone no hover
        }
    })
}
